import { VoltaTheme } from '@contact/ui-volta';

export const Tooltip = {
  baseStyle: (props) => ({
    ...VoltaTheme.components.Tooltip.baseStyle(props),
    background: 'purple.800',
  }),
};
